import actions from './actions';
import type { UserState } from './models';
import { emptyUserPreferences } from '../../core/models/user';

const initialState: UserState = {
  // Load cropwise user
  loadCropwiseUserStatus: 'idle',
  loadCropwiseUserError: null,
  userPreferences: emptyUserPreferences,
};

const reducer = (state = initialState, action: any): UserState => {
  switch (action.type) {
    case actions.LOAD_CROPWISE_USER.started().type:
      return {
        ...state,
        loadCropwiseUserStatus: 'loading',
      };
    case actions.LOAD_CROPWISE_USER.success().type:
      return {
        ...state,
        loadCropwiseUserStatus: 'success',
        baseUser: action.payload,
      };
    case actions.LOAD_CROPWISE_USER.error().type:
      return {
        ...state,
        loadCropwiseUserStatus: 'error',
        loadCropwiseUserError: action.payload,
      };
    case actions.SET_USER_CURRENT_WORKSPACE:
      return {
        ...state,
        currentWorkspaceId: action.payload,
      };
    case actions.UPADTE_USER_PREFERENCES:
      return {
        ...state,
        userPreferences: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
